import * as R from 'ramda';

export const handleErrors = callback => err => {
  const statusCode = R.path(['graphQLErrors', 0, 'extensions', 'code'], err);
  if (statusCode === 401) callback('RESET_TOKEN_EXPIRED');
  else if (statusCode === 404) callback('EMAIL_NOT_REGISTERED');
  else if (statusCode === 400) callback('EMAIL_IS_REQURIED');
  else callback('generic');
};
